import logo from './logo.svg';
import './App.scss';
import HeroSection from "../src/components/HeroSection";
import MenuOverlay from "../src/components/MenuOverlay";
import ImageCollection from "../src/components/ImageCollection";
import Musicians01 from "../src/components/Musicians01";
import Album01 from "../src/components/Album01";

import InfoSection from "../src/components/InfoSection";

import {Container} from "react-bootstrap";
import {Header}  from "../src/components/Header";
import {useState} from "react";
import ImageCollectionHorizontal from './components/ImageCollectionHorizontal';

function App() {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <div className="App">
      <Container>


      <HeroSection/>
        <InfoSection/>

        <ImageCollection imgDir="2013_laitse" count={4}/>
        
        <ImageCollection imgDir="fashion1" count={36}/>
        <ImageCollectionHorizontal imgDir="horizontal_01" count={8}/>

        <ImageCollection imgDir="portraits_01" count={6}/>
        <ImageCollectionHorizontal imgDir="portraits_02" count={2}/>

        <ImageCollectionHorizontal imgDir="landscapes_01" count={4}/>

        <ImageCollectionHorizontal imgDir="innoflame_01" count={4}/>

        <ImageCollectionHorizontal imgDir="fustra01" count={4}/>

        <ImageCollection imgDir="katrin_bridal01" count={4}/>
        <ImageCollectionHorizontal imgDir="katrin_bridal02" count={2}/>

        <ImageCollection imgDir="hair1" count={4}/>
        <ImageCollection imgDir="men01" count={6}/>


      </Container>
    </div>
  );
}

export default App;
